module.exports = __webpack_public_path__ + "93ef9732962886c55fdde2d0efc1f347.svg";